import moment from "moment";

export const stringTimeStampToDate = (timestampString: string): string => {
  const timestamp = parseInt(timestampString, 10) * 1000;
  // Format to DD/MM/YYYY
  const formattedDate = moment(timestamp).format("DD/MM/YYYY");
  return formattedDate;
};

export const timeStampToDate = (timestamp: number): string => {
  // Format to DD/MM/YYYY
  const formattedDate = moment(timestamp).format("DD/MM/YYYY");
  return formattedDate;
};
